<template>
    <div class="table_main">
        <div class="selectAll">
            <div class="right_selectall">
                <CheckBox @click.native="selectAll" :active="allSelected"></CheckBox>
                <span @click="selectAll">{{ langJson('Select all') }}</span>
            </div>
            <Sel v-model="sortType" :showBorder="true" @change="handleChange" :list="selectList"></Sel>
        </div>
        <div class="table_body">
            <div class="table_column_all" v-for="(item, index) in list" :key="index">
                <!-- 表头 -->

                <div ref="row_1" class="row_1">
                    <div class="check_name">
                        <CheckBox @click.native="selectOneItem(item)" :active="selected(item)"></CheckBox>
                        <!-- {{ list[index][checkName] }} -->
                        {{ list[index]['name'] }}
                    </div>
                    <div class="check_name_val">
                        <div>{{ list[index]['email'] }}</div>

                        <div @click="showHide(index)" class="arrow" ref="arrow"><GI class="pointer" name="select_down" ws="24" hs="24"></GI></div>
                    </div>
                </div>

                <div ref="all_rows" class="all_rows">
                    <div class="table_row" v-for="(subItem, subIndex) in listKey" :key="subIndex">
                        <div v-if="title[subItem].type == 'text' && subIndex != 0">
                            <div style="display: flex; justify-content: space-between; padding: 0px 18px">
                                <div class="title">{{ title[subItem].title }}</div>
                                <div class="text">{{ list[index][subItem] }}</div>
                            </div>
                        </div>
                        <div v-else>
                            <slot :name="subItem" :data="item"></slot>
                        </div>
                    </div>

                    <!-- 按钮，根据play数组和 -->
                    <div v-if="play.length" class="table_column play">
                        <div class="btn_item" v-for="(subItem, subIndex) in play" @click="triggleEvent(subItem.event, list[index])" :key="subIndex" :type="subItem.type" size="mini" height="32px" :load="!!loadItem">{{ subItem.title }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="table_foot">
            <slot name="foot"></slot>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => {
                return []
            },
        },
        play: {
            type: Array,
            default: () => {
                return []
            },
        },
        title: {
            type: Object,
            default: () => {
                return {}
            },
        },
        loadItem: {
            type: [String, Number],
            default: '',
        },
        commonStyle: {
            type: Boolean,
            default: false,
        },
        selectList: {
            type: Array,
            default: [],
        },
        checkName: {
            type: String,
            default: '',
        },
        checkNameVal: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            allSelected: false,
            sortType: '',
            seletelist: [],
            invitelist: [],
        }
    },
    watch: {
        sortType(n) {
            this.$emit('Sort', n)
        },
        seletelist(n) {
            this.$emit('change', n)
        },
        list: {
            handler(val) {
                try {
                    if (val.length) {
                        this.allSelected = val.every((item, index) => {
                            if (item.active) {
                                return true
                            } else {
                                return false
                            }
                        })
                    } else {
                        return false
                    }
                } catch (error) {
                    return false
                }
            },
            deep: true,
        },
    },
    mounted() {
        Object.keys(this.$slots).forEach((item) => {
            // console.log(item)
        })
        this.list.forEach((item, index) => {
            this.showHide(index)
        })
    },
    computed: {
        selected() {
            return (item) => {
                try {
                    let result = this.seletelist.some((select) => {
                        return select == item.id
                    })
                    return result
                } catch (err) {
                    console.log(err)
                }
                return false
            }
        },
        haveData() {
            return this.list && this.list.length
        },
        // title数组中的key值组成的表头数组
        listKey() {
            return Object.keys(this.title)
        },
    },
    methods: {
        inviteChange(list) {
            this.invitelist = list
        },
        selectAll() {
            console.log('select')
            this.allSelected = !this.allSelected
            if (this.allSelected) {
                this.seletelist = this.list.map((item) => {
                    return item.id
                })
            } else {
                this.seletelist = []
            }
        },
        selectOneItem(item) {
            let exit = this.seletelist.some((select) => {
                return select == item.id
            })
            if (exit) {
                this.seletelist = this.seletelist.filter((select) => {
                    return select != item.id
                })
            } else {
                this.seletelist.push(item.id)
            }
        },
        triggleEvent(event, item) {
            this.$emit(event, item)
        },
        showHide(index) {
            //点击展开收起
            let contant = this.$refs.all_rows[index] //这里我们通过参数index来让浏览器判断你点击的是哪一个列表
            let height = contant.getBoundingClientRect().height //获取页面元素的当前高度
            let row1 = this.$refs.row_1[index]
            this.$refs.arrow[index].style.transform = !!height ? `rotate(${-90}deg)` : `rotate(${0}deg)`
            // 如果有高度
            if (!!height) {
                contant.style.height = height + 'px'
                let f = document.body.offsetHeight //强制相应dom重绘，使最新的样式得到应用

                contant.style.height = '0px'
                row1.style.borderRadius = '0px'
                // 展示底部边框
                row1.className = 'row_1'
            } else {
                // 没有高度
                contant.style.height = 'auto'
                height = contant.getBoundingClientRect().height
                contant.style.height = '0'

                let f = document.body.offsetHeight
                contant.style.height = height + 'px'
                // 修改类名隐藏底部边框
                row1.className = 'row_2'
                row1.style.borderRadius = '16px'
            }
        },

        handleChange(val) {
            this.placeholder = this.selectList.find((item) => item.value == val).lable
        },
    },
}
</script>
<style lang="scss" scoped>
.table_main {
    border-radius: 12px;
    box-sizing: border-box;
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: var(--font_deep_color);
    letter-spacing: 1px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .table_body {
        border-radius: 16px;
        overflow: hidden;
    }
}
.table_column_all {
    overflow: hidden;
    .check_name {
        display: flex;
        align-items: center;
        gap: 8px;
        font-family: 'Lato';
        font-style: normal;
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: var(--font_deep_color);
    }
    .check_name_val {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 8px;
    }
    .row_1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 56px;
        padding: 12px 18px;
        box-sizing: border-box;
    }
    .row_1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: var(--color_white);
        padding: 12px 16px;
        box-sizing: border-box;
        position: relative;
    }
    &:not(:last-child) {
        .row_1::after {
            content: '';
            position: absolute;
            left: 0px;
            bottom: 0;
            width: 100%;
            height: 1px;
            border-bottom: 1px solid var(--border_color);
            box-sizing: border-box;
        }
    }
    .row_2 {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        background: var(--color_white);
        border-radius: 16px;
        box-sizing: border-box;
    }
    .all_rows {
        display: flex;
        flex-direction: column;
        gap: 12px;
        background-color: var(--bg_color);
        overflow: hidden;
        .title {
            font-family: 'Lato';
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 24px;
            color: var(--font_deep_color);
        }
        .text {
            font-family: 'Lato';
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 24px;
            color: var(--font_color);
        }
    }
}
.play {
    margin-bottom: 20px;
    padding: 0px 18px;
    color: var(--danger_color);
    font-family: 'Lato';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
}
.arrow {
    transform: rotate(-90deg);
    display: flex;
    justify-content: center;
    align-items: center;
}
.fade-enter-active,
.fade-leave-active {
    transition: all 0.5s linear;
}
.fade-leave {
    transition: all 0.5s linear;
    opacity: 0;
}
.fade-enter {
    opacity: 0;
}
.selectAll {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
    .right_selectall {
        display: flex;
        gap: 8px;
    }
    span {
        font-family: 'Lato';
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(--font_deep_color);
    }
}
</style>
